export default {
    "lang": "西班牙语",
    "application": {
        "name": "Sistema de difusión de información"
    },
    "ajaxTip": {
        "success": "Éxito",
        "error": "Fallo",
        "noAccess": "No tiene permiso para acceder a este recurso",
        "notFound": "El recurso solicitado no existe",
        "serverBusy": "El servidor está ocupado",
        "timeOut": "Tiempo de espera agotado"
    },
    "menu": {
        "home": "Inicio",
        "template": "Gestión de plantillas",
        "program": "Gestión de programas",
        "playplan": "Plan de reproducción",
        "device": "Gestión de dispositivos",
        "source-material": "Gestión de materiales",
        "material": "Materiales",
        "checkManage": "Gestión de auditorías",
        "setting": "Configuración",
        "usercenter": "Centro de usuario",
        "adminManage": "Gestión de dispositivos",
        "schedule": "Tareas pendientes",
        "capitalassets": "Gestión de activos",
        "modifyPassword": "Cambiar contraseña",
        "logout": "Cerrar sesión",
        "add": "Agregar",
        "edit": "Editar",
        "delete": "Eliminar",
        "view": "Ver",
        "menu_1": "Inicio",
        "menu_2": "Gestión de dispositivos",
        "menu_3": "Editar (Configuración avanzada - Edición básica - Cambiar red)",
        "menu_4": "Comandos instantáneos",
        "menu_5": "Editar (Transferir departamento)",
        "menu_6": "Estrategia",
        "menu_7": "Configuración de volumen",
        "menu_8": "Configuración de brillo",
        "menu_9": "Configuración de descarga",
        "menu_10": "Configuración de suspensión",
        "menu_11": "Propiedades del dispositivo",
        "menu_12": "Editar/Agregar",
        "menu_13": "Gestión de programas",
        "menu_14": "Historial de publicación",
        "menu_15": "Eliminar (Lote/Individual)",
        "menu_16": "Programas en publicación",
        "menu_17": "Agrupación",
        "menu_19": "Lista de programas",
        "menu_20": "Edición de contenido",
        "menu_21": "Copiar programa",
        "menu_23": "Publicar programa",
        "menu_24": "Gestión de materiales",
        "menu_25": "Subir",
        "menu_28": "Publicación rápida",
        "menu_29": "Gestión de plantillas",
        "menu_30": "Plantillas públicas",
        "menu_31": "Usar ahora",
        "menu_32": "Mis plantillas",
        "menu_33": "Publicar en plantillas públicas",
        "menu_35": "Registros de uso compartido",
        "menu_36": "Gestión de auditorías",
        "menu_37": "Auditoría de programas",
        "menu_38": "Auditar (Aprobar/Rechazar)",
        "menu_39": "Auditoría de materiales",
        "menu_41": "Historial de auditorías (Operador)",
        "menu_42": "Historial de auditorías (Auditor)",
        "menu_43": "Ver cantidad de aprobaciones",
        "menu_44": "Gestión de organizaciones",
        "menu_45": "Gestión de registros",
        "menu_46": "Registros de reproducción",
        "menu_47": "Registros de publicación",
        "menu_48": "Registros de errores",
        "menu_49": "Registros de operaciones",
        "menu_50": "Registros de archivos",
        "menu_51": "Registros de inicio de sesión",
        "menu_52": "Aprobación de contenido",
        "menu_53": "Espacio de almacenamiento",
        "menu_54": "Estructura organizativa",
        "menu_55": "Permisos de rol",
        "menu_56": "Autorización",
        "menu_57": "Ver (Permisos de autorización)",
        "menu_58": "Miembros de la organización",
        "menu_60": "Restablecer contraseñas de usuarios subordinados",
        "menu_61": "Gestión de activos",
        "menu_62": "Mi saldo",
        "menu_63": "Ver (Detalles de fondos)",
        "menu_64": "Mi consumo de datos",
        "menu_65": "Ver (Detalles de consumo de datos)",
        "menu_66": "Comprar consumo de datos",
        "menu_67": "Mi capacidad",
        "menu_68": "Mis dispositivos",
        "menu_69": "Detalles de pedidos",
        "menu_70": "Ver (Recargar)",
        "menu_71": "Ver (Plantillas compradas)",
        "menu_72": "Ver (Consumo de datos comprado)",
        "menu_73": "Otros permisos",
        "menu_74": "Ver (Estadísticas de materiales y programas)",
        "menu_75": "Ver (Activos)",
        "menu_76": "Ver (Consumo de datos en nube/Estadísticas)",
        "menu_77": "Ver (Estadísticas de dispositivos en línea)"
    },
    "login": {
        "terminalServiceSystem": "Sistema de servicio de terminal inteligente",
        "accountLogin": "Iniciar sesión con cuenta",
        "register": "Registrarse",
        "accountLoginTip": "Iniciar sesión con cuenta existente",
        "scanQRCode": "Escanee el código QR",
        "readAndAgree": "He leído y acepto",
        "readAndAgreeLink": "Acuerdo de servicio al usuario",
        "readAndAgreeAgreement": "Por favor, lea y acepte el acuerdo de servicio al usuario",
        "forgetpassword": "¿Olvidó la contraseña?",
        "resetpassword": "Restablecer contraseña",
        "phoneEmptyTip": "Por favor, ingrese el número de teléfono",
        "nextStep": "Siguiente paso",
        "title": "Bienvenido, inicie sesión",
        "submit": "Iniciar sesión",
        "userName": "Cuenta",
        "password": "Contraseña",
        "userNameEmptyTip": "Por favor, ingrese la cuenta",
        "passwordEmptyTip": "Por favor, ingrese la contraseña",
        "passwordFormatTip": "Por favor, ingrese el formato correcto de contraseña",
        "passwordIsOk": "Por favor, ingrese la contraseña de confirmación",
        "passwordSign": "Por favor, ingrese la contraseña",
        "codeTip": "Por favor, ingrese el código de verificación",
        "phone": "El número de teléfono no puede estar vacío",
        "code": "El código de verificación no puede estar vacío",
        "nickname": "El nombre de la empresa no puede estar vacío",
        "pass": "La contraseña no puede estar vacía",
        "pwdMessage": "La contraseña debe tener entre 8 y 20 caracteres, no puede contener espacios y debe incluir 3 de los siguientes tipos: letras mayúsculas, letras minúsculas, números, caracteres especiales",
        "pwdMessage01": "Por favor, ingrese una contraseña de al menos ocho caracteres con letras y números",
        "pwdMessage02": "La contraseña debe tener entre 8 y 20 caracteres",
        "pwdMessage03": "La contraseña no puede contener espacios",
        "pwdMessage04": "La contraseña debe incluir 3 de los siguientes tipos: letras mayúsculas, letras minúsculas, números, símbolos",
        "newpassempty": "La nueva contraseña no puede estar vacía",
        "newpass": "Las dos contraseñas no coinciden",
        "getcode": "Obtener código de verificación",
        "format": "Formato de número de teléfono incorrecto",
        "chongfa": "Reenviar en segundos",
        "isSend": "Enviado",
        "noregister": "¿No tiene una cuenta? Regístrese ahora",
        "Mobile": "Número de teléfono",
        "verificationcode": "Código de verificación",
        "petname": "Apodo",
        "Quickregistration": "Registro rápido",
        "xiugaimima": "Cambiar contraseña",
        "jiumima": "Contraseña antigua",
        "xinmima": "Nueva contraseña",
        "zaicishuruxinmima": "Ingrese la nueva contraseña nuevamente",
        "xiugaichenggong": "Cambio exitoso",
        "xiugaishoujihao": "Cambiar número de teléfono",
        "dengluzhanghao": "Cuenta de inicio de sesión",
        "gongsiid": "ID de la empresa",
        "yonghunicheng": "Apodo de usuario",
        "chuangjianshijian": "Hora de creación",
        "gongsimingcheng": "Nombre de la empresa",
        "denglumima": "Contraseña de inicio de sesión",
        "jianyi": "Se recomienda usar una contraseña combinada de letras y números",
        "shezhimima": "Establecer contraseña",
        "shezhishoujihao": "Cambiar/establecer número de teléfono",
        "yibangding": "Vinculado",
        "weibangding": "No vinculado",
        "zhanghuanquan": "Seguridad de la cuenta",
        "yonghuxinxi": "Información del usuario",
        "zhuceSucMsg": "¡Felicidades, registro exitoso!",
        "verificationcodeSucMsg": "¡Código de verificación enviado con éxito!",
        "requiredIsEmpty": "Los campos obligatorios no pueden estar vacíos!",
        "emailObj": {
            "title": "Correo electrónico",
            "tit": "Iniciar sesión con correo electrónico",
            "tip": "Por favor, ingrese la dirección de correo electrónico",
            "formatTip": "Por favor, ingrese el formato correcto de correo electrónico"
        },
        "phoneObj": {
            "title": "Número de teléfono",
            "tit": "Iniciar sesión con teléfono",
            "tip": "Por favor, ingrese el número de teléfono",
            "formatTip": "Por favor, ingrese el formato correcto de número de teléfono"
        },
        "emailOrPhoneObj": {
            "title": "Correo electrónico o número de teléfono",
            "tit": "Iniciar sesión con correo electrónico o teléfono",
            "tip": "Por favor, ingrese el correo electrónico o número de teléfono",
            "formatTip": "Por favor, ingrese el formato correcto de correo electrónico o número de teléfono"
        },
        "wechatObj": {
            "title": "WeChat",
            "tit": "Iniciar sesión con WeChat"
        },
        "googleObj": {
            "title": "Google",
            "tit": "Iniciar sesión con Google"
        },
        "confirm": "Confirmar",
        "confirmSubmit": "Enviar confirmación",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "bindSucMsg": "Vinculación exitosa",
        "toContinueBindAccount": "Continuar para completar la vinculación de cuenta de terceros",
        "bindTip01": "¿No tiene una cuenta? Cree una",
        "bindTip02": "Ya tiene una cuenta",
        "bindTip03": "La cuenta de terceros actual no está vinculada a una cuenta de la plataforma. Por favor, vincule una cuenta existente o registre y vincule una nueva cuenta para iniciar sesión rápidamente la próxima vez.",
        "bindTip04": "Vincular cuenta existente",
        "bindTip05": "Registrar y vincular nueva cuenta",
        "bindTip06": "Ha autorizado a través de terceros, complete la siguiente información de inicio de sesión para finalizar la vinculación",
        "bindSubmit": "Enviar vinculación",
        "enterAccountTip": "Por favor, ingrese el nombre de la cuenta",
        "RegisterAndBind": "Registrar y vincular",
        "loginErr": "¡Nombre de usuario o contraseña incorrectos!",
        "usercenter": "Centro de usuario",
        "pleaseInputName": "Por favor, ingrese el nombre",
        "operationSuccess": "¡Operación exitosa!",
        "edit": "Editar",
        "xiugai": "Modificar",
        "userData": "Datos personales",
        "changePassword": "Cambio de contraseña",
        "account": "Cuenta",
        "userName01": "Nombre de usuario",
        "phoneNumber": "Número de teléfono",
        "role": "Rol",
        "createTime": "Hora de creación",
        "genghuang": "Cambiar",
        "bangding": "Vincular",
        "unbind": "Desvincular",
        "plesaseSelectBindingType": "Por favor, seleccione el tipo de vinculación",
        "pleaseConfirmCont": "Por favor, confirme que ha leído este contenido",
        "confirmReadCont": "He leído este contenido",
        "frequentTip": "¡Operación demasiado frecuente, intente obtenerlo más tarde!",
        "zhuxiaoBtn": "Cancelar cuenta",
        "zhuxiaoTitle": "Cancelación de cuenta",
        "querenZhuxiao": "Confirmar cancelación",
        "jiXu": "Continuar",
        "sendCodeBtn": "Enviar código de verificación",
        "passwordIsNotOldPassword": "La contraseña de confirmación no coincide con la nueva contraseña ingresada",
        "passwordIsOldPassword": "La contraseña modificada es la misma que la contraseña original",
        "passFormatError": "Por favor, ingrese el formato correcto de contraseña",
        "oldPassWord": "Contraseña original",
        "newPassWord": "Nueva contraseña",
        "inputPlaceholder": "Por favor, ingrese",
        "confirmPassword": "Confirmar contraseña",
        "zhuxiaoTip": "\n            1、La cancelación de la cuenta es una operación irreversible. Una vez cancelada la cuenta, no podrá iniciar sesión ni usar esta cuenta ni las cuentas de terceros registradas/iniciadas sesión a través de esta cuenta. Por favor, haga una copia de seguridad de la información y datos relacionados con la cuenta por su cuenta y riesgo.\n            2、Antes de registrar esta cuenta, asegúrese de haber vaciado todos los activos y no existan disputas de ningún tipo; una vez cancelada la cuenta, se considerará que renuncia a la propiedad de todos los activos y derechos dentro de esta cuenta, y no podrán recuperarse ni recuperarse.\n            3、Si el número de teléfono registrado cancela la cuenta un total de 3 veces, este número de teléfono no podrá registrar una nueva cuenta nuevamente, ni tampoco podrá vincularse a ninguna otra cuenta.\n            "
    },
    "home": {
        "title": "Inicio",
        "quickOperation": "Operaciones rápidas",
        "addDevice": "Agregar dispositivo",
        "publishProgram": "Publicar programa",
        "publishMaterial": "Publicar material",
        "makeProgram": "Crear programa",
        "uploadMaterial": "Subir material",
        "todayData": "Datos de hoy (actualizado cada hora)",
        "playNumChart": "Estadísticas de número de reproducciones",
        "deviceOnlineStatus": "Estado de conexión de dispositivos",
        "onLineDevice": "Dispositivos en línea",
        "unLineDevice": "Dispositivos fuera de línea",
        "programPlayTime": "Estadísticas de duración de reproducción de programas",
        "downloadSoft": "Descargar software",
        "adminApp": "Aplicación móvil de usuario",
        "playerApp": "Terminal de reproducción de difusión de información",
        "downloadAdminApp": "Haga clic para descargar la aplicación de usuario",
        "downloadPlayerApp": "Haga clic para descargar la aplicación de reproducción",
        "aboutUs": "Sobre nosotros",
        "userManual": "Manual de usuario",
        "message": "Dejar un mensaje"
    },
    "device": {
        "inputPlaceholder": "Por favor, ingrese",
        "selectPlaceholder": "Por favor, seleccione",
        "osTypeStr": "Sistema de terminal",
        "onLineStatus": "Estado en línea",
        "dpi": "Resolución",
        "companyDeptIdName": "Organización a la que pertenece",
        "deviceGroupIdName": "Grupo al que pertenece",
        "editOrMove": "Editar/Mover",
        "loanOriginationFee": "Tarifa de origen de préstamo",
        "strategyInfoLook": "Ver información de estrategia",
        "programLook": "Ver programa",
        "addEquipments": "Agregar equipos",
        "luminanceSet": "Control de brillo",
        "terminal": "Configuración de terminal",
        "transferCompany": "Transferir departamento",
        "releasedProgram": "Publicar programa",
        "screenshot": "Captura de pantalla",
        "changeGroup": "Cambiar grupo",
        "defaultGroup": "Grupo predeterminado",
        "operation": "Operación",
        "edit": "Editar",
        "saveEdit": "Guardar edición",
        "add": "Agregar",
        "save": "Guardar",
        "setting": "Configuración",
        "program": "Programa",
        "unbind": "Desvincular",
        "sleep": "Modo de suspensión",
        "wakeup": "Despertar",
        "restart": "Reiniciar",
        "shutdown": "Apagar",
        "reportLog": "Enviar registro",
        "clearPlayData": "Limpiar datos del terminal de reproducción",
        "offlineWarn": "Este dispositivo está fuera de línea, por favor, inténtelo nuevamente cuando el dispositivo esté en línea!",
        "confirmUnbind": "Confirmar desvinculación",
        "confirmReset": "Confirmar limpieza",
        "confirmDelete": "Confirmar eliminación",
        "delete": "Eliminar",
        "cancelDelete": "Cancelar eliminación",
        "confirmResetSuccess": "Limpieza exitosa",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "operationSuccess": "Operación exitosa",
        "unbindSuccess": "Desvinculación exitosa",
        "pleaseSelectDevice": "Por favor, seleccione un dispositivo",
        "pleaseSelectOnlineDevice": "Por favor, seleccione un dispositivo en línea",
        "confirmMixOperation": "Los dispositivos seleccionados incluyen dispositivos fuera de línea, esta configuración no surtirá efecto en los dispositivos fuera de línea, ¿confirmar continuar con la operación?",
        "pleaseSelectDate": "Por favor, seleccione una fecha",
        "reportSuccess": "Envío exitoso",
        "deviceSetting": "Configuración de dispositivo",
        "default": "Predeterminado",
        "all": "Todos",
        "deviceList": "Lista de dispositivos",
        "addDevice": "Agregar dispositivo",
        "department": "Organización de departamentos",
        "deviceType": "Resolución",
        "osType": "Sistema de terminal",
        "onlineState": "Estado en línea",
        "online": "En línea",
        "offline": "Fuera de línea",
        "notActive": "No activado",
        "search": "Por favor, ingrese palabras clave",
        "batchOperation": "Operación por lotes",
        "allDevices": "Todos los dispositivos",
        "deviceAttribute": "Atributos del dispositivo",
        "selectReportDate": "Seleccionar fecha de envío",
        "inputName": "Por favor, ingrese el nombre",
        "inputWidth": "Por favor, ingrese el ancho",
        "inputHeight": "Por favor, ingrese la altura",
        "inputResolutionRatio": "Por favor, ingrese un número entero mayor que 0!",
        "inputSort": "Por favor, ingrese el orden",
        "serialNum": "Número de serie",
        "name": "Nombre",
        "width": "Ancho",
        "height": "Altura",
        "resolutionRatio": "Resolución",
        "inputResolutionRatioName": "Por favor, ingrese el nombre de la resolución",
        "sort": "Orden",
        "personal": "Personal",
        "system": "Sistema",
        "type": "Tipo",
        "systemDefaultSettingUneditable": "¡La configuración predeterminada del sistema no se puede editar!",
        "systemDefaultSettingUnDeletable": "¡La configuración predeterminada del sistema no se puede eliminar!",
        "newz": "Nuevo",
        "total": "Total",
        "totalNum": "ítems",
        "strategyName": "Nombre de la estrategia",
        "associatedTerminalNum": "Número de terminales asociados",
        "createTime": "Hora de creación",
        "pleaseSelectStrategy": "¡Por favor, seleccione una estrategia!",
        "onlySelectOneData": "¡Solo se puede seleccionar un dato!",
        "downloadStrategy": "Descargar estrategia",
        "inputStrategyName": "Por favor, ingrese el nombre de la estrategia",
        "luminanceControl": "Control de brillo",
        "volumeStrategy": "Estrategia de volumen",
        "saveSuccess": "Guardado exitoso",
        "screenAngle": "Rotación de pantalla (°)",
        "startTime": "Hora de inicio",
        "endTime": "Hora de finalización",
        "repeat": "Repetir",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Miércoles",
        "thursday": "Jueves",
        "friday": "Viernes",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "everyday": "Todos los días",
        "downloadSpeed": "Velocidad de descarga",
        "inputDownloadSpeed": "Por favor, ingrese la velocidad de descarga",
        "operator": "Operación",
        "pleaseSelectDeleteData": "¡Por favor, seleccione los datos a eliminar!",
        "confirmBatchDelete": "¿Confirmar eliminación por lotes?",
        "pleaseInputName": "Por favor, ingrese el nombre",
        "detailSetting": "Configuración detallada",
        "weekPlan": "Plan semanal",
        "specialDateSetting": "Configuración de fechas especiales",
        "weekdayInfo": "¡El día de la semana es un campo obligatorio!",
        "volumeInfo": "¡El volumen es un campo obligatorio!",
        "timeError": "¡Error en la selección de tiempo!",
        "editSuccess": "¡Operación de edición exitosa!",
        "addSuccess": "¡Operación de adición exitosa!",
        "addSpecialPlan": "Agregar plan de estrategia especial",
        "downloadSpeedInfo": "Velocidad de descarga: (0 significa prohibir la descarga)",
        "pleaseSelectStartTime": "Por favor, seleccione la hora de inicio",
        "pleaseSelectEndTime": "Por favor, seleccione la hora de finalización",
        "luminanceError": "¡Por favor, ingrese un valor de brillo correcto!",
        "defaultLuminance": "Brillo predeterminado",
        "luminance": "Nivel de brillo",
        "defaultLuminanceInfo": "Brillo predeterminado (100 significa el más brillante, 0 significa el más oscuro)",
        "volume": "Volumen",
        "saveLuminance": "Guardar brillo",
        "changeSuccess": "¡Cambio exitoso!",
        "changeNetwork": "Cambiar red",
        "netName": "Nombre de la red",
        "nameempty": "El nombre de la red no puede estar vacío",
        "currentNetwork": "Red actual",
        "ipAddress": "Dirección IP",
        "dailyMode": "Modo diario",
        "weeklyMode": "Modo semanal",
        "turnOnTime": "Hora de encendido",
        "turnOffTime": "Hora de apagado",
        "startSleep": "Inicio de suspensión",
        "endSleep": "Fin de suspensión",
        "batchDelInfo": "¿Confirmar eliminar los elementos seleccionados?",
        "timeCannotBeEmpty": "¡El tiempo no puede estar vacío!",
        "startUp": "Encender",
        "shutDown": "Apagar",
        "volumeSize": "Nivel de volumen",
        "defaultVolume": "Volumen predeterminado (100 significa el máximo, 0 significa silencio)",
        "chooseStartTime": "Por favor, seleccione la hora de inicio",
        "chooseEndTime": "Por favor, seleccione la hora de finalización",
        "saveVolume": "Guardar volumen",
        "screenRotationUnSaved": "La rotación de pantalla no se ha guardado",
        "volumeSettingUnSaved": "La configuración de volumen no se ha guardado",
        "luminanceSettingUnSaved": "La configuración de brillo no se ha guardado",
        "confirmClosePopup": "¿Confirmar cerrar esta ventana emergente?",
        "volumeSettingSuccess": "Cambio de volumen exitoso",
        "luminanceSettingSuccess": "Cambio de brillo exitoso",
        "advancedSettingUnSaved": "La configuración avanzada no se ha guardado",
        "settingTitle": "Configuración de terminal",
        "volumeSetting": "Configuración de volumen",
        "luminanceSetting": "Configuración de brillo",
        "downloadSetting": "Configuración de descarga",
        "sleepSetting": "Configuración de suspensión",
        "onOffSetting": "Encendido/apagado programado",
        "screenRotation": "Rotación de pantalla",
        "namingError": "Error de nomenclatura, el nombre de archivo no puede contener espacios!",
        "deleteSuccess": "Eliminación exitosa",
        "deleteFolder": "Eliminar carpeta",
        "pleaseInputDeviceName": "Por favor, ingrese el nombre del dispositivo",
        "pleaseInputDeviceId": "Por favor, ingrese el ID del dispositivo",
        "discoverDevice": "Descubrir dispositivo",
        "deviceId": "ID del dispositivo",
        "bound": "Vinculado",
        "bind": "Vincular",
        "noDevice": "No hay dispositivos",
        "refresh": "Actualizar",
        "manualAdd": "Agregar manualmente",
        "deviceGroup": "Clasificación de dispositivos",
        "pleaseSelectGroup": "¡Por favor, seleccione un grupo!",
        "deviceName": "Nombre del dispositivo",
        "goAdd": "Ir a agregar",
        "close": "Cerrar",
        "bindCountInsufficient": "Cantidad de vinculaciones insuficiente, por favor, actualice la cantidad de dispositivos antes de agregar!",
        "displayNumber": "Número de visualización",
        "groupName": "Nombre del grupo",
        "pleaseSelectGroupName": "¡Por favor, ingrese el nombre del grupo!",
        "moveGroup": "Mover grupo",
        "longitude": "Longitud",
        "latitude": "Latitud",
        "nationality": "Nacionalidad",
        "province": "Provincia",
        "city": "Ciudad",
        "county": "Condado",
        "outNetIp": "IP externa",
        "inNetIp": "IP interna",
        "companyName": "Nombre de la empresa",
        "Info": "Detalles",
        "android": "Android",
        "win": "Windows",
        "osVersion": "Versión del sistema",
        "softwareVersion": "Versión del software",
        "diskSize": "Tamaño del disco",
        "useSize": "Tamaño utilizado",
        "macAddr": "Dirección MAC",
        "longitudeLatitudeInfo": "¡La longitud y latitud deben estar vacías o no vacías al mismo tiempo!",
        "terminalName": "Nombre del terminal",
        "terminalGroup": "Grupo de terminales",
        "reportJournal": "¿Enviar registro?",
        "systemVersion": "Versión del sistema",
        "storageSpace": "Espacio de almacenamiento",
        "resolution": "Resolución",
        "runningMemory": "Memoria RAM",
        "model": "Modelo",
        "registerStatus": "Estado de registro",
        "password": "Contraseña",
        "passwordInfo": "¡Por favor, ingrese entre 6 y 18 letras o números!",
        "group": "Grupo",
        "address": "Dirección",
        "remark": "Nota",
        "renewalPeriod": "Período de renovación",
        "money": "Costo",
        "latitudeInfo": "¡Por favor, ingrese una latitud correcta!",
        "totalPayment": "Monto total",
        "longitudeInfo": "¡Por favor, ingrese una longitud correcta!",
        "setMeal": "Paquete",
        "number": "Cantidad",
        "programName": "Nombre del programa",
        "playStatus": "Estado de reproducción",
        "playType": "Modo de reproducción",
        "play": "Reproducir",
        "pause": "Pausar",
        "playTime": "Tiempo de reproducción",
        "programDeleted": "Programa eliminado",
        "playSuccess": "El programa ha sido programado para reproducirse",
        "pauseSuccess": "Pausa exitosa",
        "playCycle": "Reproducción cíclica",
        "playInsert": "Reproducción insertada",
        "withdrawSuccess": "Retirada exitosa",
        "withdrawInfo": "¡Por favor, seleccione primero el programa a retirar!",
        "programBelong": "Programa al que pertenece",
        "checkAll": "Seleccionar todo",
        "batchDel": "Eliminar por lotes",
        "delConfirm": "¿Confirmar eliminar los elementos seleccionados?",
        "check": "Seleccionado",
        "noProgram": "No hay programas",
        "details": "Detalles",
        "screenshotFail": "Fallo en captura de pantalla",
        "policyName": "Nombre de la política",
        "terminalNum": "Número de terminales asociados",
        "powerStrategy": "Estrategia de alimentación",
        "pleaseSelectDepartment": "¡Por favor, seleccione un departamento!",
        "screenshotControl": "Control de captura de pantalla",
        "未激活": "No activado",
        "已激活": "Activado",
        "未绑定": "No vinculado",
        "已绑定": "Vinculado"
    },
    "programManage": {
        "programList": "Lista de programas",
        "publishProgram": "Seguimiento de publicación de programas",
        "week1": "Lunes",
        "week2": "Martes",
        "week3": "Miércoles",
        "week4": "Jueves",
        "week5": "Viernes",
        "week6": "Sábado",
        "week7": "Domingo",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Miércoles",
        "thursday": "Jueves",
        "friday": "Viernes",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "name": "Nombre",
        "preview": "Vista previa",
        "playDeviceNum": "Número de dispositivos de reproducción",
        "copyDeviceCode": "Haga clic para copiar",
        "osType": "Tipo de sistema",
        "playDate": "Fecha de reproducción",
        "playWeek": "Semana de reproducción",
        "everyday": "Todos los días",
        "start": "Desde",
        "end": "Hasta",
        "playOperateStatusStr": "Estado de publicación",
        "playDevice": "Dispositivo de reproducción",
        "downloadView": "Ver descargas",
        "publisher": "Publicador",
        "publishTime": "Hora de publicación",
        "operation": "Operación",
        "add": "Agregar",
        "groupName": "Nombre del grupo",
        "selectDevice": "Seleccionar terminal",
        "searchDevice": "Buscar terminal",
        "pleaseFillGroupName": "¡Por favor, ingrese el nombre del grupo!",
        "remarkInfo": "Nota",
        "compile": "Editar",
        "withdrawConfirm": "¿Confirmar retirar este programa?",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "withdraw": "Retirar",
        "batchWithdraw": "Retirar por lotes",
        "batchPublish": "Publicar por lotes",
        "batchDelete": "Eliminar por lotes",
        "batchOperation": "Operación por lotes",
        "notUse": "No utilizado",
        "notChecked": "No auditado",
        "notPass": "No aprobado",
        "delete": "Eliminar",
        "publishTextLeft": "Publicado",
        "offTextLeft": "Pausado",
        "pleaseSelectProgramToMove": "¡Por favor, seleccione el programa a transferir!",
        "pause": "Pausar",
        "pauseConfirm": "¿Confirmar pausa?",
        "play": "Reproducir",
        "downloadUdisk": "Descargar a USB",
        "deviceList": "Lista de dispositivos",
        "groupSelection": "Selección de grupo",
        "operationSuccess": "Operación exitosa",
        "deleteSuccess": "Eliminación exitosa",
        "selectDate": "Seleccionar fecha",
        "publishStatus": "Estado de publicación",
        "checkStatus": "Estado de auditoría",
        "waitAuditing": "Pendiente de auditoría",
        "auditPass": "Auditoría aprobada",
        "auditRefuse": "Auditoría rechazada",
        "all": "Todos",
        "playStatus": "Reproduciendo",
        "playStatust": "Estado de reproducción",
        "pauseStatus": "Pausado",
        "notStartStatus": "No iniciado",
        "resolutionratio": "Resolución",
        "totalNum": "ítems",
        "programName": "Nombre del programa",
        "playStartTime": "Hora de inicio de reproducción",
        "playEndTime": "Hora de finalización de reproducción",
        "createTime": "Hora de creación",
        "nationality": "Nacionalidad",
        "province": "Provincia",
        "city": "Ciudad",
        "county": "Distrito/condado",
        "address": "Dirección",
        "ip": "Dirección IP",
        "location": "Ubicación",
        "log": "Registro",
        "pleaseFillProgramName": "¡Por favor, ingrese el nombre del programa!",
        "selectGroup": "Seleccionar grupo",
        "startTime": "Hora de inicio",
        "endTime": "Hora de finalización",
        "publishCycle": "Ciclo de publicación",
        "publishDeviceNum": "Número de dispositivos publicados",
        "pleaseSelectRecord": "Por favor, seleccione un registro",
        "deviceName": "Nombre del terminal",
        "deviceId": "ID del dispositivo terminal",
        "deviceGroupIdName": "Grupo al que pertenece",
        "notClassified": "No clasificado",
        "osTypeStr": "Sistema de terminal",
        "storageSpace": "Espacio de almacenamiento",
        "onLineStatus": "Estado en línea",
        "onLine": "En línea",
        "offLine": "Fuera de línea",
        "sleep": "Suspensión",
        "unknown": "Desconocido",
        "registerStatus": "Estado de registro",
        "trialPeriod": "Período de prueba",
        "notActive": "No activado",
        "active": "Activado",
        "parameterError": "¡Parámetros incorrectos!",
        "pleaseSelectProgram": "¡Por favor, seleccione un programa!",
        "pleaseSelectProgramEdit": "¡Por favor, seleccione el programa a editar!",
        "confirmWithdrawSelectedProgram": "¿Confirmar retirar los programas seleccionados?",
        "withdrawSuccess": "Retirada exitosa",
        "allPrograms": "Todos los programas",
        "defaultGroup": "Grupo predeterminado",
        "cannotShareEmptyProgram": "¡No se puede compartir un programa vacío!",
        "onlyShareYourProgram": "¡Solo puede compartir los programas que ha creado!",
        "pleaseSelectProgramEditPublishTime": "¡Por favor, seleccione el programa con la hora de publicación editada!",
        "pleaseSelectDevice": "¡Por favor, seleccione un dispositivo!",
        "programDetail": "Detalles del programa",
        "errorReason": "Motivo del error",
        "availableStorageSpaceInsufficient": "Espacio de almacenamiento disponible insuficiente",
        "partialDeviceReleaseFailure": "Fallo en la publicación en algunos dispositivos",
        "allDeviceReleaseSuccess": "Publicación exitosa en todos los dispositivos",
        "partialDeviceReleaseSuccess": "Publicación exitosa en algunos dispositivos",
        "allGroup": "Todos los grupos",
        "allProgram": "Todos los programas",
        "unGrouped": "No agrupado",
        "replaceProgram": "Reemplazar programa",
        "replaceProgramTip": "El nuevo programa publicado reemplazará los datos de programas existentes enviados al terminal de reproducción!",
        "screen": "Pantalla única/dual",
        "singleScreen": "Pantalla única",
        "doubleScreen": "Pantalla dual",
        "playSetting": "Configuración de reproducción",
        "batchPlaySetting": "Configurar tiempo de reproducción por lotes",
        "individualPlaySetting": "Configurar tiempo de reproducción uno por uno",
        "playTime": "Tiempo de reproducción",
        "daily": "Diariamente",
        "weekdays": "Lunes a viernes",
        "monthly": "Este mes",
        "advancedSetting": "Configuración avanzada",
        "playProgram": "Reproducir programa",
        "searchProgram": "Por favor, ingrese palabras clave",
        "shareAddressNotExist": "La dirección de enlace no existe, por favor, inténtelo nuevamente",
        "copySuccess": "Copia exitosa",
        "shareLink": "Enlace de compartir",
        "publish": "Publicar",
        "noResource": "No hay recursos",
        "single": "Pantalla única",
        "double": "Pantalla dual",
        "time": "Tiempo",
        "associatedTerminalNum": "Número de terminales asociados",
        "default": "Predeterminado",
        "moveGroup": "Mover grupo",
        "pleaseSelectGroup": "¡Por favor, ingrese el nombre del grupo!",
        "copy": "Copiar",
        "FUBEN": "Copia",
        "nameempty": "El nombre no puede estar vacío",
        "whitespace": "Error de nomenclatura, el nombre de archivo no puede contener espacios!",
        "programWhitespace": "Error de nomenclatura, el nombre del programa no puede contener espacios!",
        "pleaseSelectResolution": "¡Por favor, seleccione la resolución!",
        "dataError": "¡Datos incorrectos!",
        "createProgram": "Crear nuevo programa",
        "directCreate": "Crear directamente",
        "myTemplate": "Mis plantillas",
        "use": "Usar",
        "free": "Gratis",
        "loadMore": "Cargar más",
        "confirmDelete": "Confirmar eliminación",
        "deleteGroup": "Eliminar grupo",
        "notPublished": "No publicado",
        "notPassed": "No aprobado",
        "notUsed": "No utilizado",
        "confirmDeleteSelectedProgram": "¿Confirmar eliminar los programas seleccionados?",
        "companyName": "Nombre de la empresa",
        "programCannotDownload": "¡Este programa no se puede descargar!",
        "publishMaterial": "Publicar material",
        "playMaterial": "Reproducir material",
        "pleaseInputMaterialName": "Por favor, ingrese el nombre del material",
        "size": "Tamaño",
        "pleaseInputDeviceName": "Por favor, ingrese el nombre del dispositivo",
        "item": "ítems",
        "allMaterial": "Todos los materiales",
        "allDevices": "Todos los dispositivos",
        "saveSuccess": "Guardado exitoso",
        "savefaill": "Error al guardar",
        "playMode": "Modo de reproducción",
        "cyclePlay": "Reproducción cíclica",
        "insertPlay": "Reproducción insertada",
        "noData": "Sin datos disponibles",
        "Add": "Agregar",
        "replace": "Reemplazar",
        "repeat": "Repetir",
        "start01": "Inicio",
        "end01": "Fin",
        "startDate": "Fecha de inicio",
        "endDate": "Fecha de fin",
        "useNow": "Usar inmediatamente",
        "fillStartEndTimeFirst": "Complete primero la hora de inicio y fin antes de agregar",
        "fillFullPlayTime": "Complete la duración de reproducción completa",
        "fillCorrectPlayTime": "Complete el período de reproducción correcto",
        "sDateAndEDateBothEmptyOrFilled": "La fecha de inicio y la fecha de fin deben estar ambas vacías o ambas completadas"
    },
    "source": {
        "addResource": "Agregar recurso",
        "width": "Ancho",
        "height": "Alto",
        "size": "Tamaño (KB)",
        "name": "Nombre",
        "pleaseInputResourceName": "¡Por favor, ingrese el nombre del recurso!",
        "addToGroup": "Agregar al grupo",
        "remark": "Nota",
        "promptFgIllustrate": "Ilustración",
        "promptFgRealisticPhoto": "Foto realista",
        "promptFgSimplisticDrawing": "Dibujo sencillo",
        "promptFgChineseStyle": "Estilo chino",
        "promptFgPixelArt": "Arte de píxeles",
        "noModel": "¡No hay modelos disponibles, contacte al administrador!",
        "getModelFailed": "¡Error al obtener el modelo, inténtelo nuevamente más tarde! O contacte al administrador!",
        "createImagePrompt": "Generando imagen, no cierre la ventana por favor!",
        "promptEmpty": "Por favor, ingrese el prompt",
        "dpiEmpty": "¡Por favor, seleccione la proporción de la imagen!",
        "fgEmpty": "¡Por favor, seleccione el estilo!",
        "style": "Estilo",
        "idEmpty": "El ID de la imagen no puede estar vacío",
        "exist": "Esta imagen ya existe en los materiales",
        "addSuccess": "Material agregado exitosamente",
        "saveError": "¡Error al guardar la imagen, inténtelo nuevamente más tarde!",
        "delSuccess": "Eliminación exitosa",
        "generateImage": "Texto a imagen",
        "generateImagePlaceholder": "Ingrese lo que desea generar, ej: Una mariposa revoloteando en un campo de flores",
        "aiExpand": "Ampliación inteligente",
        "negativePrompt": "Prompt negativo",
        "negativePromptTooltip": "Se utiliza para excluir explícitamente contenido o características que el usuario no desea que aparezcan en la salida",
        "imageRatio": "Proporción de imagen",
        "generateImageBtn": "Generar inmediatamente",
        "shengchengjieguo": "Resultado de generación",
        "generateImageLoadingTip": "Generando, no haga clic repetidamente ni cierre la ventana...",
        "Tooltip": "¡Venga, da rienda suelta a tu creatividad con IA!",
        "saveToMaterial": "Guardar en materiales",
        "publish": "Publicar inmediatamente",
        "download": "Descargar",
        "generateHistory": "Historial de generaciones",
        "hide": "Contraer",
        "cancel": "Cancelar",
        "useExpand": "Usar ampliación",
        "all": "Todos",
        "delete": "Eliminar",
        "loadMore": "Cargar más",
        "aiTip": "El contenido es generado por un modelo de inteligencia artificial y no representa los puntos de vista, posiciones ni actitudes de la plataforma. Por favor, utilice el contenido de IA de manera legal y conforme.",
        "operationSuccess": "Operación exitosa",
        "moveGroup": "Mover grupo",
        "groupName": "Nombre del grupo",
        "pleaseSelectGroup": "¡Por favor, seleccione el nombre del grupo!",
        "shenhe": "Auditoría",
        "shenheStatus": "Estado de auditoría",
        "shenheSuccess": "Auditoría aprobada",
        "shenheRefuse": "Auditoría rechazada",
        "pleaseSelectShenheStatus": "¡Por favor, seleccione el estado de auditoría!",
        "shenheRemark": "Nota de auditoría",
        "pleaseInputShenheRemark": "¡Por favor, ingrese la nota de auditoría!",
        "pleaseInputFileName": "¡Por favor, ingrese el nombre del archivo!",
        "whitespace": "Error de nomenclatura, el nombre del archivo no puede contener espacios!",
        "dataError": "¡Datos incorrectos!",
        "confirmDelete": "Confirmar eliminación",
        "confirm": "Confirmar",
        "deleteFolder": "Eliminar carpeta",
        "add": "Agregar",
        "edit": "Editar",
        "fileName": "Nombre del archivo",
        "group": "Grupo",
        "resolution": "Resolución",
        "type": "Tipo",
        "image": "Imagen",
        "music": "Música",
        "video": "Video",
        "uploadTime": "Hora de subida",
        "uploadUser": "Usuario que subió",
        "checkTime": "Hora de auditoría",
        "checkUser": "Usuario que auditó"
    },
    "setting": {
        "nameempty": "El nombre no puede estar vacío",
        "heightempty": "La altura no puede estar vacía",
        "widthempty": "El ancho no puede estar vacío",
        "resolutionratio": "Resolución",
        "name": "Nombre",
        "opteration": "Operación",
        "compile": "Editar",
        "delete": "Eliminar",
        "newz": "Nuevo",
        "compileratio": "Editar resolución",
        "sheizhifenbianlvmingcheng": "Establecer nombre de resolución",
        "shezhigaodu": "Establecer altura",
        "shezhikuandu": "Establecer ancho",
        "xinzengfenbianlv": "Agregar resolución",
        "bianma": "Codificación",
        "bianjizhongduanmingcheng": "Editar nombre de terminal",
        "xinzengzhongduan": "Agregar terminal",
        "selectPrimaryColor": "Seleccionar color temático",
        "fullScreen": "Pantalla completa",
        "exitFullScreen": "Salir de pantalla completa"
    },
    "tabs": {
        "refresh": "Actualizar",
        "refreshAll": "Actualizar todo",
        "close": "Cerrar",
        "closeOthers": "Cerrar otros",
        "closeAll": "Cerrar todos",
        "closeLeft": "Cerrar izquierdos",
        "closeRight": "Cerrar derechos"
    },
    "errorPage": {
        "needLogin": "¡Aún no has iniciado sesión!",
        "pageNotFound": "¡La página que intentas acceder no existe!",
        "redirectTo": "Redirigir a",
        "orReturn": "o regresar a",
        "previousStep": "Paso anterior"
    },
    "headerUs": {
        "systemNotice": "Notificación del sistema",
        "allNotices": "Todas las notificaciones",
        "viewAllMessages": "Ver todos los mensajes",
        "contactUs": "Contáctenos",
        "operationSuccess": "¡Operación exitosa!",
        "leaveMessage": "Dejar un mensaje",
        "messageTitle": "Título",
        "messageTitleTip": "¡Por favor, ingrese el título!",
        "messageContentTip": "Máximo 150 caracteres",
        "submit": "Enviar",
        "markAsRead": "Marcar como leído",
        "success": "¡Operación exitosa!"
    },
    "material": {
        "allMaterial": "Todos los materiales",
        "defaultGroup": "Grupo predeterminado",
        "auditStatus": "Estado de auditoría",
        "auditPassed": "Auditoría aprobada",
        "auditRejected": "Auditoría rechazada",
        "pendingAudit": "Pendiente de auditoría",
        "all": "Todos",
        "operateSuccess": "¡Operación exitosa!",
        "pleaseSelectMaterial": "¡Por favor, seleccione materiales!",
        "moveGroup": "Mover grupo",
        "pleaseSelectGroup": "¡Por favor, seleccione un grupo!",
        "batchPublish": "Publicar por lotes",
        "batchRecall": "Retirar por lotes",
        "batchDelete": "Eliminar por lotes",
        "materialList": "Lista de materiales",
        "uploadMaterial": "Subir materiales",
        "materialType": "Tipo de material",
        "pleaseInputMaterialName": "Por favor, ingrese el nombre del material",
        "selectAll": "Seleccionar todo",
        "confirmDeleteSelectedMaterial": "¿Confirmar eliminar los materiales seleccionados?",
        "deleteSuccess": "Eliminación exitosa",
        "delete": "Eliminar",
        "publish": "Publicar",
        "recall": "Retirar",
        "confirmRecallSelectedMaterial": "¿Confirmar retirar los materiales seleccionados?",
        "pleaseSelectMaterialGroup": "¡Por favor, seleccione el grupo de materiales!",
        "recallSuccess": "Retirada exitosa",
        "publishSuccess": "Publicación exitosa",
        "batchOperate": "Operación por lotes",
        "item": "ítems",
        "confirmDelete": "¿Confirmar eliminación?",
        "edit": "Editar",
        "confirmRecall": "¿Confirmar retirada?",
        "unaudited": "No auditado",
        "notPassed": "No aprobado",
        "operate": "Operación",
        "resolution": "Resolución",
        "none": "Ninguno",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "AICreation": "Creación IA"
    },
    "uploadFile": {
        "operationSuccess": "Operación exitosa",
        "uploadFile": "Gestión de subidas",
        "uploadSuccess": "Subida exitosa",
        "uploadCompleted": "Subida completada",
        "uploadFail": "Subida fallida",
        "ConversionFailed": "¡Conversión fallida!",
        "loading": "Cargando intensamente...",
        "beQueuing": "En cola...",
        "Uploading": "Subiendo...",
        "ConversionIng": "Convirtiendo...",
        "ConventionalResources": "Recursos convencionales",
        "DocumentResources": "Recursos de documentos",
        "complete": "Completado",
        "upload": "Subir",
        "fileSizeWraning01": "El tamaño del material excede",
        "fileSizeWraning02": "¡Por favor, modifíquelo y vuelva a subir!",
        "fileIsEmpty": "El archivo está vacío",
        "uploadFileTip": "Formato de archivo no compatible",
        "unablePreview": "No se agregó exitosamente a la biblioteca de materiales, no se puede previsualizar",
        "confirmDelete": "¿Confirmar eliminación?",
        "deleteSuccess": "Eliminación exitosa",
        "delete": "Eliminar",
        "confirm": "Confirmar",
        "preview": "Previsualizar",
        "close": "Cerrar",
        "cancel": "Cancelar",
        "fileType": "Tipo de archivo",
        "fileSize": "Tamaño de archivo",
        "conversionProgress": "Progreso de conversión",
        "progress": "Progreso",
        "image": "Imagen",
        "video": "Video",
        "audio": "Música",
        "limitTip01": "Subir a la vez",
        "limitTip02": "archivos",
        "okTip": "Subiendo materiales, no cierre la ventana por favor!",
        "usableSize": "Capacidad disponible",
        "sizeUnableTip": "La capacidad de almacenamiento disponible actual es insuficiente. Por favor, limpie los materiales inútiles a tiempo para ahorrar espacio o contacte al distribuidor para ampliar la capacidad de almacenamiento en la nube. Este servicio puede generar costos, consulte la información del distribuidor para más detalles.",
        "view": "Ver detalles",
        "fileName": "Nombre del archivo"
    },
    "template": {
        "inputPlaceholder": "Por favor, ingrese",
        "selectPlaceholder": "Por favor, seleccione",
        "noAuths": "No tiene permisos, contacte al administrador",
        "operationSuccess": "Operación exitosa",
        "total": "Total",
        "totalNum": "ítems",
        "dan": "Simple",
        "shaung": "Doble",
        "pleaseSelectGroup": "Por favor, seleccione un grupo",
        "preview": "Previsualizar",
        "free": "Gratis",
        "use": "Usar",
        "dpi": "Resolución",
        "delete": "Eliminar",
        "confirmDelete": "Confirmar eliminación",
        "confirmDeleteSelectedTemplate": "¿Confirmar eliminar esta plantilla?",
        "push": "Publicar",
        "pushConfirm": "¿Confirmar publicar en plantillas públicas?",
        "pushRemovalConfirm": "¿Confirmar retirar de plantillas públicas?",
        "templateOrderRecord": "Registro de pedidos de plantillas",
        "unpublished": "No publicado",
        "auditing": "En auditoría",
        "publishRejected": "Publicación rechazada",
        "publishSuccess": "Publicación exitosa",
        "offShelf": "Retirar del catálogo",
        "公共模版": "Plantillas públicas",
        "我的模板": "Mis plantillas",
        "共享记录": "Registro de compartir",
        "name": "Nombre",
        "pubdate": "Fecha de publicación",
        "keySeachTip": "Por favor, ingrese palabras clave",
        "allGroup": "Todos los grupos",
        "add": "Agregar",
        "edit": "Editar",
        "programName": "Nombre del programa",
        "selectGroup": "Seleccionar grupo"
    },
    "checkManage": {
        "total": "Total",
        "totalNum": "ítems",
        "operationSuccess": "Operación exitosa",
        "checkUserLogs": "Registro de auditorías (Operador)",
        "checkLogs": "Registro de auditorías (Auditor)",
        "sourceCheck": "Auditoría de materiales",
        "programCheck": "Auditoría de programas",
        "checkAll": "Seleccionar todo",
        "auditPass": "Auditoría aprobada",
        "auditRefuse": "Auditoría rechazada",
        "auditPass01": "Aprobado",
        "auditRefuse01": "Rechazado",
        "auditRefuse02": "Rechazar auditoría",
        "auditor": "Auditor",
        "agentUserName": "Publicador",
        "interrogationTime": "Hora de solicitud de auditoría",
        "checkTime": "Hora de auditoría",
        "checkName": "Nombre de auditoría",
        "checkType": "Categoría de auditoría",
        "checkIp": "Dirección IP de solicitud de auditoría",
        "checkReason": "Comentario",
        "checkStatus": "Contenido de operación",
        "rangePicker": "Fecha de auditoría",
        "keyWord": "Palabra clave",
        "all": "Todos",
        "program": "Programa",
        "material": "Material",
        "dan": "Simple",
        "shaung": "Doble",
        "pleaseSelectProgram": "¡Por favor, seleccione un programa!",
        "pleaseSelectMaterial": "¡Por favor, seleccione materiales!",
        "preview": "Previsualizar",
        "dpi": "Resolución",
        "auditRefuseTip": "Por favor, ingrese el motivo del rechazo",
        "unreviewed": "No auditado",
        "notPassed": "No aprobado",
        "notUsed": "No utilizado",
        "edit": "Editar",
        "none": "Ninguno",
        "name": "Nombre",
        "size": "Tamaño",
        "type": "Tipo",
        "uploadTime": "Hora de subida",
        "uploadUser": "Usuario que subió",
        "checkUser": "Auditor",
        "image": "Imagen",
        "music": "Música",
        "video": "Video"
    },
    "systemSet": {
        "total": "Total",
        "totalNum": "ítems",
        "inputPlaceholder": "Por favor, ingrese",
        "selectPlaceholder": "Por favor, seleccione",
        "userList": "Miembros de la organización",
        "roleList": "Permisos de rol",
        "department": "Estructura organizacional",
        "diskInfo": "Espacio de almacenamiento",
        "approveSet": "Aprobación de contenido",
        "logList": "Gestión de registros",
        "name": "Nombre",
        "account": "Cuenta",
        "userName": "Nombre de usuario",
        "phoneNumber": "Número de teléfono",
        "role": "Rol",
        "createTime": "Hora de creación",
        "operation": "Operación",
        "edit": "Editar",
        "delete": "Eliminar",
        "addNew": "Nuevo",
        "add": "Agregar",
        "resetPassword": "Restablecer contraseña",
        "confirmDelete": "Confirmar eliminación",
        "departmentOrganization": "Organización de departamentos",
        "addNewUser": "Agregar nuevo usuario",
        "pleaseEnterUserName": "Por favor, ingrese el nombre de usuario",
        "confirmPasswordNotMatch": "¡La contraseña de confirmación no coincide con la contraseña ingresada!",
        "operationSuccess": "¡Operación exitosa!",
        "userNickname": "Nombre de usuario",
        "pleaseEnterUserNickname": "Por favor, ingrese el nombre de usuario",
        "userNicknameRequired": "¡El nombre de usuario no puede estar vacío!",
        "password": "Contraseña",
        "pleaseEnterPassword": "Por favor, ingrese la contraseña",
        "passwordRequired": "¡La contraseña no puede estar vacía!",
        "passwordTip": "Su contraseña es demasiado insegura (debe contener al menos 3 de los siguientes tipos: letras mayúsculas, letras minúsculas, números, caracteres especiales y tener una longitud de 8",
        "confirmPassword": "Confirmar contraseña",
        "pleaseEnterPhoneNumber": "Por favor, ingrese el número de teléfono",
        "phoneNumberRequired": "¡El número de teléfono no puede estar vacío!",
        "phoneNumberFormatError": "¡Por favor, ingrese un número de teléfono válido!",
        "roleRequired": "¡El rol no puede estar vacío!",
        "required": "¡No puede estar vacío!",
        "departmentName": "Departamento",
        "modifyPassword": "Modificar contraseña",
        "newPassword": "Nueva contraseña",
        "pleaseEnterNewPassword": "Por favor, ingrese la nueva contraseña",
        "pwdMessage": "La contraseña debe tener entre 8 y 20 caracteres, no puede contener espacios y debe incluir 3 de los siguientes tipos: letras mayúsculas, letras minúsculas, números, caracteres especiales",
        "all": "Todos",
        "noAuths": "No tiene permisos, contacte al administrador",
        "departmentName01": "Nombre del departamento",
        "image": "Imagen",
        "music": "Música",
        "video": "Video",
        "buySize": "Cantidad comprada",
        "totalMoney": "Monto pagado",
        "buycreateTime": "Hora de compra",
        "endTime": "Fecha de vencimiento",
        "buyTypeStr": "Tipo de pedido",
        "sourceCheck": "Auditoría de materiales",
        "programCheck": "Auditoría de programas",
        "programName": "Nombre del programa",
        "diskExpansion": "Se recomienda limpiar los materiales vencidos/no utilizados a tiempo durante el uso para garantizar la capacidad disponible del sistema. Si necesita más espacio, puede contactar a su proveedor de equipos para obtener el servicio de ampliación de capacidad de almacenamiento en la nube. Este servicio puede generar costos, consulte la información del distribuidor para más detalles.",
        "selectPermission": "Por favor, seleccione permisos",
        "checkPermission": "Por favor, marque los permisos",
        "addRole": "Agregar rol",
        "enterRoleName": "Por favor, ingrese el nombre del rol",
        "roleName": "Nombre del rol",
        "roleNameRequired": "¡El nombre del rol no puede estar vacío!",
        "remark": "Nota",
        "enterRemark": "Por favor, ingrese una nota",
        "permissionSetting": "Configuración de permisos",
        "deleteSuccess": "¡Eliminación exitosa!",
        "confirmToDelete": "¿Confirmar eliminación?",
        "orgName": "Nombre de la organización",
        "orgNameRequired": "¡El nombre de la organización no puede estar vacío!",
        "orgRemark": "Nota de la organización",
        "enterOrgRemark": "Por favor, ingrese una nota de la organización",
        "capacityUsage": "Uso de capacidad",
        "usedCapacity": "Capacidad utilizada",
        "totalCapacity": "Capacidad total",
        "remainingCapacity": "Capacidad restante",
        "capacityExpansion": "Ampliación de capacidad",
        "enable": "Activar",
        "disable": "Desactivar",
        "userName01": "Nombre de usuario",
        "loginTime": "Hora de inicio de sesión",
        "ipAddress": "Dirección IP",
        "loginResult": "Resultado de inicio de sesión",
        "selectDate": "Seleccionar fecha",
        "enterDate": "Por favor, seleccione una fecha",
        "selectStartTime": "Por favor, seleccione la hora de inicio",
        "selectEndTime": "Por favor, seleccione la hora de finalización",
        "enterUserName": "Por favor, ingrese el nombre de usuario",
        "userCount": "Número de usuarios",
        "roleDesc": "Descripción del rol",
        "roleAuthorization": "Autorización de rol",
        "success": "Éxito",
        "failure": "Fallo",
        "time": "Tiempo",
        "operationContent": "Contenido de operación",
        "playCount": "Número de reproducciones",
        "playDuration": "Duración de reproducción",
        "selectDevice": "Seleccionar dispositivo",
        "enterProgramName": "Por favor, ingrese el nombre del programa",
        "serialNumber": "Número de serie",
        "publishContentName": "Nombre del contenido publicado",
        "playMode": "Modo de reproducción",
        "cyclePlay": "Reproducción cíclica",
        "insertPlay": "Reproducción insertada",
        "paddingPlay": "Reproducción de relleno",
        "playDeviceId": "ID del dispositivo de reproducción",
        "playDeviceName": "Nombre del dispositivo de reproducción",
        "publishTime": "Hora de publicación",
        "downloadStatus": "Estado de descarga",
        "notDownloaded": "No descargado",
        "downloading": "Descargando",
        "downloadSucceeded": "Descarga exitosa",
        "downloadFailed": "Descarga fallida",
        "enterPublishContentName": "Por favor, ingrese el nombre del contenido publicado",
        "terminalId": "ID de terminal",
        "belongOrg": "Organización a la que pertenece",
        "reportTime": "Hora de informe",
        "reportIp": "IP de informe",
        "logInfo": "Información de registro",
        "details": "Detalles",
        "confirmDeletion": "¿Confirmar eliminación?",
        "logDetails": "Detalles de registro",
        "download": "Descargar",
        "deptOrg": "Organización de departamentos",
        "query": "Consultar",
        "queryByTerminalId": "Consultar por ID de terminal",
        "batchDeleteLogs": "Eliminar registros por lotes",
        "customTimeDeleteLogs": "Eliminar registros en tiempo personalizado",
        "selectTimeRangeFirst": "Por favor, seleccione primero un rango de tiempo",
        "deleteAllDeviceLogsIfEmpty": "Si no ingresa el ID del dispositivo, se eliminarán los registros de todos los dispositivos por defecto",
        "enterDeviceIdToDeleteLogs": "Por favor, ingrese el ID del dispositivo cuyos registros desea eliminar",
        "confirmDeleteAction": "Confirmar eliminación",
        "selectDeleteRangeFirst": "Por favor, seleccione primero el rango de eliminación",
        "networkConnectionFailed": "Fallo en la conexión de red",
        "playLog": "Registro de reproducción",
        "publishLog": "Registro de publicación",
        "errorLog": "Registro de errores",
        "operationLog": "Registro de operaciones",
        "fileLog": "Registro de archivos",
        "userOperateLog": "Registro de inicio de sesión"
    },
    "userManual": {
        "userManual": "Manual de usuario",
        "noData": "No hay datos disponibles"
    },
    "systemNotice": {
        "systemNotice": "Notificación del sistema",
        "noData": "No hay datos disponibles",
        "total": "Total",
        "totalNum": "ítems",
        "markAllRead": "Marcar todo como leído",
        "deleteAll": "Eliminar todo",
        "all": "Todos",
        "unread": "No leído",
        "read": "Leído",
        "type": "Tipo",
        "content": "Contenido",
        "date": "Fecha",
        "status": "Estado",
        "confirmDelete": "¿Confirmar eliminación?",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "delete": "Eliminar"
    }
};